<template>
    <div id="comic_diversity">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/novel_list' }">{{$t('menu.work_manag')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('novelist.chapters')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <el-form ref="form" label-width="80px" :inline="true" size="small">
                <el-form-item>
                    <el-button type="primary" size="small" @click="add">{{$t('_add')}}</el-button>
                    <el-button type="primary" size="small" @click="addWhole">{{$t('_add_whole')}}</el-button>
                    <el-button type="warning" size="small" @click="book_list_release" :disabled="selections.length<=0">{{$t('_release_selected')}}</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="index"
                        :label="$t('_index')">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="title"
                        :label="$t('novelist.chapter_title')">
                </el-table-column>
                <el-table-column
                        prop="chaps"
                        :label="$t('novelist.chapter_index')">
                </el-table-column>
                <el-table-column
                        :label="$t('books.checkStus')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.review_status==-1">{{$t('books.unpublished')}}</span>
                        <span v-if="scope.row.review_status==0">{{$t('books.checking')}}</span>
                        <span v-if="scope.row.review_status==1">{{$t('books.passed')}}</span>
                        <span v-if="scope.row.review_status==2">{{$t('books.failed')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('_action')"
                        min-width="300">
                    <template slot-scope="scope">
                        <p style="text-align: center">
                            <el-button type="success" plain @click="onPush(scope.row.id)" size="small" v-if="scope.row.review_status==-1 || scope.row.review_status==2">{{$t('novelist.release')}}</el-button>
                            <el-button type="primary" plain size="small" @click="edit(scope.row.id)" v-if="scope.row.review_status==-1 || scope.row.review_status==2 ">{{$t('_edit')}}</el-button>
                            <el-button type="warning" plain size="small" @click="remove(scope.row.id)">{{$t('_delete')}}</el-button>
                        </p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :layout="this.$store.state.paginationLayout"
                        :total="params.totals">
                </el-pagination>
            </div>
        </el-card>

        <el-dialog :title="allfrom.title" :width="this.$store.state.dialogWidth":visible.sync="allfrom.visible">
            <el-form ref="form" :label-width="this.$store.state.labelWidth" size="mini">
                <el-form-item :label="$t('spreator_type')" >
                    <el-select v-model="allfrom.plame_type" :placeholder="$t('placeholder_spreator_type')"
                               :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-option :label="$t('separator')" value="1"></el-option>
                        <el-option :label="$t('number_of_chars')" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('separator')" v-if="allfrom.plame_type==1">
                    <el-input v-model="allfrom.separator"  :placeholder="$t('placeholder_separ')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('number_of_chars')" v-if="allfrom.plame_type==2">
                    <el-input v-model="allfrom.separat_num" :placeholder="$t('placeholder_number')" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-upload
                            ref="all_inputer"
                            :limit="1"
                            action="upDataUrl"
                            :show-file-list="true"
                            :http-request="myUpload1"
                    >
                        <el-button size="small" type="primary">{{$t('_select_file')}}</el-button>
                    </el-upload>
                    <span class="input_hint">{{$t('hit_whole_add')}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="allfrom.visible = false" size="mini">{{$t('_cancel')}}</el-button>
                <el-button type="primary" @click="bookSubmit" size="mini">{{$t('_ok')}}</el-button></span>
        </el-dialog>

    </div>
</template>

<script>
  import {isRealNum, uploadimg} from "../../utils/common";
  import quillConfigText from '../../utils/quill-text-config'
  import {showFullScreenLoading, tryHideFullScreenLoading} from "../../utils/axios";
  import config from "../../config";

  export default {
    name: "comic_diversity",
    data() {
      return {
        params: {
          pagenum: 1,
          pagesize: 10,
          totals: 0
        },
        tableData: [],
        fromTitle: '',
        visible: false,
        anid: '',//小说id
        id: '',//分集id
        editorOption: quillConfigText,
          selections:[],
        formTitle: '',
          allfrom:{
              title:this.$i18n.t('_add_whole'),
              visible:false,
              plame_type:'1',
              file_name:'',
              separator:'###Chapter',
              separat_num:2000,
          },
      }
    },
    created() {
      this.anid = this.$route.query.id;
      this.getList()
    },
    methods: {
        handleSelectionChange(val){
            this.selections=val;
        },

        book_list_release(){
            let ids =this.selections.map(item=>{return item.id});
            this.onPush(ids);
        },

        addWhole(){
            this.allfrom = {
                title:this.$i18n.t('_add_whole'),
                visible:true,
                plame_type:'1',
                file_name:'',
                separator:'###Chapter',
                separat_num : 2000,
            };
            this.allfrom.visible=true;
          if(this.$refs['all_inputer']) this.$refs['all_inputer'].value =''
        },

        myUpload1(content) {
            showFullScreenLoading();
            uploadimg(content).then(res => {
                tryHideFullScreenLoading();
                this.allfrom.file_name = res;
            })
        },

        upload_txt_uri(){
          return config.server_url+'writer/common/uploadFile';
        },
        upload_txt_headers(){
         return    {
                'Content-Type': 'multipart/form-data',
                'access-token': sessionStorage.getItem("token")
            }
        },
        upload_txt_before(file){
            showFullScreenLoading();
        },
        upload_txt_sucess(response,file,fileList){
            tryHideFullScreenLoading();
            let result = response.data.file_name;
            this.allfrom.file_name=result;
        },


        bookSubmit(){
            this.allfrom = Object.assign({anid: this.anid}, this.allfrom);
            showFullScreenLoading();
            this.$axios.post('writer/chapter/all', this.allfrom).then((res) => {
                this.$message.success('ok');
                this.getList();
                this.allfrom.visible = false;
                tryHideFullScreenLoading();
            });
        },

      getList() {
        let data = {
          anid: this.anid,
          page: this.params.pagenum,
          page_size: this.params.pagesize,
        };
        this.$axios.post("writer/chapter/index", data).then((res) => {
          this.params.totals = res.data.count;
          this.tableData = res.data.list;
        });
      },
      // 每页显示多少条
      changeSize(val) {
        this.params.pagesize = val;
        this.getList()
      },
      // 当前显示的页数
      changeCurrent(val) {
        this.params.pagenum = val;
        this.getList()
      },
      add() {
        this.$router.push({
          path: '/novel_chapters',
          query: {
            anid: this.anid
          }
        })
      },
      edit(id) {
        this.id = id;
        this.$router.push({
          path: '/novel_chapters',
          query: {
            id: this.id,
            anid: this.anid
          }
        })
      },
      onPush(id) {
          this.$confirm(this.$i18n.t('_public_chapter_dailog'), this.$i18n.t('_attention'), {
              confirmButtonText:this.$i18n.t('_ok') ,
              cancelButtonText: this.$i18n.t('_cancel'),
              type: 'warning'
        }).then(() => {
          this.$axios.post("writer/chapter/push", {ids: (id instanceof Array)?id:[id] ,anid:this.anid}).then((res) => {
            this.$message.success(this.$i18n.t('_ok'));
            this.getList();
          });
        })
      },
      remove(id) {
          this.$confirm(this.$i18n.t('_continue_dailog'), this.$i18n.t('_attention'), {
              confirmButtonText:this.$i18n.t('_ok') ,
              cancelButtonText: this.$i18n.t('_cancel'),
              type: 'warning'
        }).then(() => {
          this.$axios.del('writer/chapter/' + id, '').then((res) => {
            this.$message.success(this.$i18n.t('_ok') );
            this.getList();
          });
        })
      },
    }
  }
</script>

<style scoped>
</style>